<template>
  <div class="charge-new">
    <a
      v-if="allowCreateCharge"
      href="#"
      class="btn btn-primary"
      ref="openChargeButton"
      @click.prevent="openChargeModal">Adicionar recarga</a>
    <router-link
      v-else
      class="btn btn-primary"
      :to="{ name: 'financialData', params: { financialProps: financialData, returnTo: $route.name }}">
      Para realizar recargas informe seus dados aqui
    </router-link>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="chargeRequest"
      ref="chargeRequest"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-lg modal-dialog-centered charge-add-modal"
        role="document">
        <div class="modal-content">
          <div class="modal-header charge-add-modal-header">
            <div class="charge-add-modal-header-left">
              <Icon name="sync-plus" :size="28" icon-class="charge-add-modal-header-icon" />
              <h5 class="modal-title">Adicionar Recarga</h5>
            </div>
            <button
              type="button"
              class="close"
              @click.prevent="closeChargeModal">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center charge-add-modal-body">
            <ErrorAlert :error="error" />
            <form
              ref="chargeForm"
              class="charge-form">
              <div class="form-group">
                <h3 class="charge-add-label">Informe o <b>valor da recarga</b> que deseja</h3>
              </div>
              <div class="form-group row">
                <div class="col-sm-12 chargeAmount">
                  <CurrencyAmountInput
                    ref="chargeAmount"
                    v-model="chargeAmount"
                    :min="250"
                    :max="50000"
                    @enter="submitCharge" />
                </div>
              </div>
              <div v-if="hasDynamicTariff">
                <div class="form-group">
                  <h3 class="charge-add-label">Ou selecione o <b>desconto</b> que deseja receber</h3>
                </div>
                <div class="form-group row">
                  <div :class="`col ${sliderName}`">
                    <div
                      class="range-slider"
                      @click.prevent="sliderClick">
                      <input
                        class="form-control"
                        :id="sliderName"
                        type="input"
                        data-slider-tooltip="hide"
                        :data-slider-ticks-snap-bounds="sliderTicksSnapBounds"
                        :data-slider-ticks-labels="sliderTicksLabels"
                        :data-ticks_positions="sliderTicksPositions">
                    </div>
                  </div>
                </div>
                <div class="form-group row charge-add-prices">
                  <div class="col-lg-6"><h5 class="charge-add-price-label">Minuto Móvel</h5></div>
                  <div class="col-lg-6"><h5 class="charge-add-price-label">Minuto Fixo</h5></div>
                </div>
                <div class="row">
                  <div class="col-sm-6"><h2 class="charge-add-price-value">R$ {{ mobilePrice }}</h2></div>
                  <div class="col-sm-6"><h2 class="charge-add-price-value">R$ {{ fixedlinePrice }}</h2></div>
                </div>
                <div>
                  <p
                    v-if="chargeAmount >= 500"
                    class="charge-add-economy-text">
                    Com esse desconto, a cada <b>1000 minutos</b> você economizará em média <b>R$ {{ averageSaving }},00</b>
                  </p>
                </div>
              </div>
            </form>
            <div
              v-if="showDueDatePicker"
              class="form-group text-left charge-add-due-date">
              <label
                id="chargeDueDateLabel"
                class="col-form-label d-flex align-items-center">
                <i class="ik ik-calendar charge-add-label-icon mr-2" />
                Data de Vencimento
              </label>
              <input
                id="chargeDueDate"
                ref="chargeDueDate"
                type="text"
                class="form-control charge-add-email-input"
                aria-labelledby="chargeDueDateLabel"
                readonly>
              <small class="form-text charge-add-helper">Selecione uma data entre 3 e 30 dias a partir de hoje.</small>
            </div>
            <div class="form-group text-left charge-add-financial-emails">
              <label
                for="chargeAdditionalEmails"
                class="col-form-label d-flex align-items-center">
                <i class="ik ik-mail charge-add-label-icon mr-2" />
                Confirme o e-mail do financeiro
                <i
                  id="charge-financial-emails-info"
                  class="ik ik-info charge-add-info-icon ml-2"
                  style="cursor: pointer;" />
              </label>
              <b-tooltip
                target="charge-financial-emails-info"
                triggers="hover"
                placement="top">
                Esses e-mails receberão notificações financeiras como envio de cobranças, confirmação de pagamento, notas fiscais e comprovantes.
              </b-tooltip>
              <input
                id="chargeAdditionalEmails"
                type="text"
                class="form-control charge-add-email-input"
                v-model="additionalEmails"
                placeholder="email@exemplo.com, outro@exemplo.com">
              <small class="form-text charge-add-helper">Você pode adicionar até 5 e-mails separados por vírgula.</small>
            </div>
            <hr>
            <CompensationTermsMethods
              title="Prazos de compensação"
              description="Após a compensação do pagamento, seus créditos serão adicionados automaticamente à sua conta." />
            <p v-if="showRechargeActiveUserLimitNotice" class="charge-limit-message">
              <button
                type="button"
                class="charge-limit-icon-btn"
                @click.prevent="goToSubscription">
                <i class="ik ik-info charge-limit-icon" />
              </button>
              <span>
                No modelo de recarga você tem limite de até {{ rechargeActiveUsersLimitLabel }} usuários.
                <a
                  href="#"
                  class="charge-limit-link"
                  @click.prevent="goToSubscription">
                  Aumente seu limite com modelo de planos &rarr;
                </a>
              </span>
            </p>
          </div>
          <div class="modal-footer charge-add-modal-footer">
            <div class="buttons">
              <button
                type="button"
                class="btn charge-add-btn-cancel"
                @click.prevent="closeChargeModal">Cancelar</button>
              <button
                type="button"
                class="btn charge-add-btn-submit"
                @click.prevent="submitCharge">Gerar pagamento</button>
              <PlansCallToAction @click.prevent="closeChargeModal" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="chargeAsaasSuccess"
      ref="chargeAsaasSuccess"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-lg modal-dialog-centered charge-success-modal"
        role="document">
        <div class="modal-content">
          <div class="modal-header charge-success-modal-header">
            <div class="charge-success-header-left">
              <span class="charge-success-badge">
                <Icon name="circle-check" :size="24" />
              </span>
              <h5 class="modal-title">Recarga gerada com sucesso!</h5>
            </div>
            <button
              type="button"
              class="close"
              aria-label="Close"
              @click.prevent="closeChargeSuccessAsaasModal">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center charge-success-modal-body">
            <p class="charge-success-cta">
              Para realizar o pagamento
              <a
                class="link charge-success-link"
                :href="paymentLink"
                target="_blank">
                clique aqui
              </a>
            </p>
            <p class="charge-success-desc">Após a compensação do pagamento, seus créditos serão adicionados automaticamente à sua conta.</p>
            <CompensationTermsMethods
              no-margin-top
              title="Prazos de compensação" />
          </div>
          <div class="modal-footer charge-success-modal-footer">
            <button
              type="button"
              class="btn charge-success-btn-ok"
              @click.prevent="closeChargeSuccessAsaasModal">OK</button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="chargeErrorModal"
      ref="chargeErrorModal"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <h1>Infelizmente tivemos um problema ao gerar sua recarga :~(</h1>
            <p class="support-message-error">
              Porfavor, entre em contato com nosso suporte
              <a
                href="https://wa.me/+554833328503"
                class="link"
                target="_blank">(48) 3332-8503 (WhatsApp)</a>
            </p>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-secondary"
              data-dismiss="modal"
              aria-label="OK">OK</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import loopback from '@/services/loopback'
import { EventBus } from '@/services/event-bus'
import { getInviteEligibility, resolveInviteEligibilityMaxUsers, isOrganizationUserLimitExempt } from '@/services/invite-eligibility'
import DatepickerLanguages from '../Report/datepickerLanguages'
import PlansCallToAction from '@/components/Common/PlansCallToAction.vue'
import CompensationTermsMethods from '@/components/Common/CompensationTermsMethods.vue'
import CurrencyAmountInput from '@/components/Common/CurrencyAmountInput.vue'
import Icon from '@/components/Common/Icon.vue'
const LEGACY_MOBILE_PRICES = ['0,35', '0,33', '0,30', '0,25', '0,19', '0,12']
const LEGACY_FIXEDLINE_PRICES = ['0,08', '0,079', '0,078', '0,076', '0,074', '0,07']

const MOBILE_PRICES = ['0,38', '0,36', '0,33', '0,28', '0,22', '0,15']
const FIXEDLINE_PRICE = '0,09'

const NEW_MOBILE_PRICES = ['0,41', '0,39', '0,36', '0,31', '0,25', '0,18']
const NEW_FIXEDLINE_PRICE = '0,09' // TEL-2294: sem valor próprio definido, assumido igual ao "Atual"

const CHARGE_AMOUNTS = [250, 500, 1000, 2000, 3000, 5000]
const CHARGE_AMOUNT_TIERS = [0, 5, 15, 30, 45, 65]
const CHARGE_AMOUNT_POSITIONS = [0, 20, 40, 60, 80, 100]
const MIN_CHARGE_AMOUNT = 250
const MAX_CHARGE_AMOUNT = 50000
const MIN_DUE_DATE_DAYS = 3
const MAX_DUE_DATE_DAYS = 30
const CHARGE_AMOUNT_RANGE_MESSAGE = 'Recarga mínima é de R$ 250,00 e máxima de R$ 50.000,00'
const DUE_DATE_RANGE_MESSAGE = 'Data de vencimento deve estar entre 3 e 30 dias a partir de hoje.'
const SUBMIT_DEBOUNCE_MS = 5000

export default {
  name: 'ChargeNew',
  components: {
    Icon,
    PlansCallToAction,
    CompensationTermsMethods,
    CurrencyAmountInput
  },
  props: {
    sliderName: {
      type: String,
      default: 'chargeAmountSlider'
    }
  },
  data () {
    return {
      chargeAmount: MIN_CHARGE_AMOUNT,
      error: null,
      paymentLink: null,
      additionalEmails: '',
      dueDate: null,
      isRolloutRechargeDueDate: false,
      sliderTicks: CHARGE_AMOUNT_POSITIONS,
      sliderTicksPositions: CHARGE_AMOUNT_POSITIONS,
      sliderTicksLabels: CHARGE_AMOUNT_TIERS.map(v => `${v}%`),
      sliderTicksSnapBounds: 20,
      financialData: null,
      rechargeActiveUsersLimit: null,
      inviteEligibilityCutoffDate: null,
      canInvite: true,
      isRateplanLegacy: typeof this.$store.state.auth.organization.isRateplanLegacy === 'boolean'
        ? this.$store.state.auth.organization.isRateplanLegacy
        : true,
      isRatePlanNew: typeof this.$store.state.auth.organization.isRatePlanNew === 'boolean'
        ? this.$store.state.auth.organization.isRatePlanNew
        : false,
      hasDynamicTariff: this.$store.state.auth.softswitchIntegration &&
        typeof this.$store.state.auth.softswitchIntegration.metadata.hasDynamicTariff === 'boolean'
        ? this.$store.state.auth.softswitchIntegration.metadata.hasDynamicTariff
        : true
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.getFinancialData()
      this.loadInviteEligibility()
      this.loadRolloutRechargeDueDate()
    })
  },
  methods: {
    async loadInviteEligibility () {
      const eligibility = await getInviteEligibility()
      this.rechargeActiveUsersLimit = resolveInviteEligibilityMaxUsers(eligibility)
      this.inviteEligibilityCutoffDate = eligibility ? eligibility.cutoffDate : null
      this.canInvite = eligibility && eligibility.canInvite !== false
    },
    loadRolloutRechargeDueDate () {
      loopback
        .get('/rollout?featureFlag=recharge-due-date')
        .then(rollout => {
          this.isRolloutRechargeDueDate = rollout === 'ALLOWED'
        })
        .catch(() => {
          this.isRolloutRechargeDueDate = false
        })
    },
    addDays (days) {
      const date = new Date()
      date.setHours(0, 0, 0, 0)
      date.setDate(date.getDate() + days)
      return date
    },
    toIsoDate (date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    initDueDatePicker () {
      if (!this.showDueDatePicker) return
      $.fn.datepicker.dates['pt-BR'] = DatepickerLanguages['pt-BR']
      const initialDate = this.minDueDate
      this.dueDate = initialDate
      $(this.$refs.chargeDueDate)
        .datepicker({
          language: 'pt-BR',
          container: this.$refs.chargeRequest,
          autoclose: true,
          todayHighlight: true,
          startDate: initialDate,
          endDate: this.maxDueDate,
          format: 'dd/mm/yyyy',
          orientation: 'bottom auto'
        })
        .on('changeDate', this.handleDueDateChange)
        .datepicker('setDate', initialDate)
    },
    destroyDueDatePicker () {
      const $input = $(this.$refs.chargeDueDate)
      if ($input.length && $input.data('datepicker')) {
        $input.off('changeDate', this.handleDueDateChange)
        $input.datepicker('destroy')
      }
      this.dueDate = null
    },
    handleDueDateChange (event) {
      this.dueDate = event.date
    },
    resetCharge () {
      this.chargeAmount = MIN_CHARGE_AMOUNT
      this.error = null
      this.syncAdditionalEmailsFromFinancialData()
    },
    syncAdditionalEmailsFromFinancialData () {
      this.additionalEmails = this.financialData && this.financialData.additionalEmails
        ? this.financialData.additionalEmails
        : ''
    },
    submitCharge (event) {
      this.debounceSubmitSource(event)
      this.error = null
      if (!this.isChargeAmountInRange()) {
        return this.showAmountRangeError()
      }
      if (!this.isDueDateInRange()) {
        return this.showDueDateRangeError()
      }
      const form = this.$refs.chargeForm
      if (form && !form.checkValidity()) {
        return this.showAmountRangeError()
      }
      this.saveFinancialEmailsIfDirty()
        .then(() => this.createChargeRequest())
        .catch(() => {})
    },
    saveFinancialEmailsIfDirty () {
      const isDirty = this.financialData &&
        String(this.additionalEmails || '').trim() !== String(this.financialData.additionalEmails || '').trim()
      if (!isDirty) return Promise.resolve()
      return loopback
        .put('/accounts/financial', { additionalEmails: this.additionalEmails })
        .then(updated => {
          if (updated) this.$store.commit('auth/setFinancialData', updated)
        })
        .catch(err => {
          const msg = err.message || ''
          if (msg.includes('additionalEmails: invalid')) {
            this.error = msg.includes('maximum 5 emails')
              ? { message: 'Máximo de 5 emails adicionais.' }
              : { message: 'Emails adicionais inválidos. Exemplo: "contato@dominio.com,financeiro@dominio.com"' }
          } else {
            // TEL-2243: `msg` e a mensagem do backend — nao vai para a tela.
            this.error = { lines: ['Não foi possível atualizar os e-mails.'] }
          }
          this.focusAmountInput()
          return Promise.reject(err)
        })
    },
    debounceSubmitSource (event) {
      if (!event) return
      event.preventDefault()
      const source = event.target
      const isSubmitTrigger = source && (source.tagName === 'INPUT' || source.tagName === 'BUTTON')
      if (isSubmitTrigger) {
        source.disabled = true
        setTimeout(() => { source.disabled = false }, SUBMIT_DEBOUNCE_MS)
      }
    },
    isChargeAmountInRange () {
      return this.chargeAmount >= MIN_CHARGE_AMOUNT && this.chargeAmount <= MAX_CHARGE_AMOUNT
    },
    isDueDateInRange () {
      if (!this.showDueDatePicker) return true
      if (!(this.dueDate instanceof Date)) return false
      return this.dueDate >= this.minDueDate && this.dueDate <= this.maxDueDate
    },
    showAmountRangeError () {
      this.error = { message: CHARGE_AMOUNT_RANGE_MESSAGE }
      return this.focusAmountInput()
    },
    showDueDateRangeError () {
      this.error = { message: DUE_DATE_RANGE_MESSAGE }
    },
    focusAmountInput () {
      this.$refs.chargeAmount.focus()
    },
    openChargeModal () {
      this.syncAdditionalEmailsFromFinancialData()
      const $modal = $(this.$refs.chargeRequest)
      $modal.one('shown.bs.modal', () => {
        this.$nextTick(() => {
          setTimeout(() => {
            this.refreshChargeSlider()
            this.initDueDatePicker()
          }, 50)
        })
      })
      $modal.one('hidden.bs.modal', () => {
        this.destroyDueDatePicker()
      })
      $modal.appendTo('body').modal('show')
    },
    refreshChargeSlider () {
      const $slider = $(`#${this.sliderName}`)
      if ($slider.length && $slider.data('slider')) {
        $slider.slider('destroy')
      }
      this.buildSlider()
      const $sliderWidget = $(this.$refs.chargeRequest).find('.slider.slider-horizontal')
      if ($sliderWidget.length) {
        $sliderWidget.css('width', '90%')
      }
    },
    closeChargeModal () {
      this.resetCharge()
      $(this.$refs.chargeRequest).modal('hide')
      this.$refs.openChargeButton.focus()
    },
    createChargeRequest () {
      const dueDate = this.showDueDatePicker ? this.dueDate : this.addDays(MIN_DUE_DATE_DAYS)
      loopback.post('/charges', {
        amount: this.chargeAmount,
        paymentMethod: 'UNDEFINED',
        dueDate: this.toIsoDate(dueDate)
      }).then(charge => {
        EventBus.$emit('reload-charge-history', charge.amount)
        $(this.$refs.chargeRequest).modal('hide')
        if (charge && charge.paymentLink) {
          this.paymentLink = charge.paymentLink
          $(this.$refs.chargeAsaasSuccess).appendTo('body').modal('show')
          window.open(this.paymentLink, '_blank')
        } else {
          $(this.$refs.chargeErrorModal).appendTo('body').modal('show')
        }
      }).catch(err => {
        if (err.details && err.details.messages && err.details.messages.dueDate) {
          this.error = { message: err.details.messages.dueDate[0] }
          this.focusAmountInput()
        } else {
          this.error = {
            lines: ['Infelizmente tivemos um problema ao gerar sua recarga'],
            support: true
          }
        }
      })
    },
    closeChargeSuccessAsaasModal () {
      this.resetCharge()
      $(this.$refs.chargeAsaasSuccess).modal('hide')
      this.$refs.openChargeButton.focus()
    },
    goToSubscription () {
      const $modal = $(this.$refs.chargeRequest)
      this.resetCharge()
      $modal.one('hidden.bs.modal', () => {
        this.$router.push('/subscription')
      })
      $modal.modal('hide')
    },
    getAmountByPosition (position) {
      return CHARGE_AMOUNTS[CHARGE_AMOUNT_POSITIONS.findIndex(v => parseInt(v) === parseInt(position))]
    },
    getPositionByAmount (amount) {
      const positionIndex = CHARGE_AMOUNTS.reduce((findIndex, tier, index) => {
        if (parseInt(amount) >= parseInt(tier)) {
          findIndex = index
        }
        return findIndex
      }, 0)
      return positionIndex
    },
    getAmountPositionByAmount (amount) {
      return CHARGE_AMOUNT_POSITIONS[this.getPositionByAmount(amount)]
    },
    buildSlider () {
      $(`#${this.sliderName}`).slider({
        value: this.getAmountPositionByAmount(this.chargeAmount),
        ticks: this.sliderTicks,
        ticks_positions: this.sliderTicksPositions,
        ticks_labels: this.sliderTicksLabels,
        ticks_snap_bounds: this.sliderTicksSnapBounds
      }).on('slide', (slideEvt) => {
        this.chargeAmount = this.getAmountByPosition(slideEvt.value)
      })
    },
    sliderClick () {
      this.chargeAmount = this.getAmountByPosition($(`#${this.sliderName}`)[0].value)
    },
    getFinancialData () {
      this.financialData = this.$store.state.auth.financialData
      this.syncAdditionalEmailsFromFinancialData()
    },
    mobileUsageByTierIndex (tierIndex) {
      const prices = this.isRatePlanNew ? NEW_MOBILE_PRICES : (this.isRateplanLegacy ? LEGACY_MOBILE_PRICES : MOBILE_PRICES)
      const tariff = Number((prices[tierIndex] || prices[0]).replace(',', '.'))
      return isNaN(tariff) ? 0 : tariff * 1000
    },
    fixedlineUsageByTierIndex (tierIndex) {
      const source = this.isRatePlanNew ? [NEW_FIXEDLINE_PRICE] : (this.isRateplanLegacy ? LEGACY_FIXEDLINE_PRICES : [FIXEDLINE_PRICE])
      const price = Array.isArray(source) ? source[tierIndex] || source[0] : FIXEDLINE_PRICE
      const tariff = Number((price || FIXEDLINE_PRICE).replace(',', '.'))
      return isNaN(tariff) ? 0 : tariff * 1000
    }
  },
  computed: {
    showRechargeActiveUserLimitNotice () {
      const organization = this.$store.state.auth.organization || {}
      if (isOrganizationUserLimitExempt(organization)) return false
      const createdAtRaw = organization.created_at || organization.createdAt
      if (this.inviteEligibilityCutoffDate && createdAtRaw) {
        const createdAt = new Date(createdAtRaw)
        const cutoffDate = new Date(this.inviteEligibilityCutoffDate)
        if (!isNaN(createdAt.getTime()) && !isNaN(cutoffDate.getTime())) {
          return createdAt >= cutoffDate
        }
      }
      return !this.canInvite
    },
    rechargeActiveUsersLimitLabel () {
      if (this.rechargeActiveUsersLimit === null) return 'N/D'
      return this.rechargeActiveUsersLimit
    },
    tierIndex () {
      return this.getPositionByAmount(this.chargeAmount)
    },
    mobilePrice () {
      const prices = this.isRatePlanNew ? NEW_MOBILE_PRICES : (this.isRateplanLegacy ? LEGACY_MOBILE_PRICES : MOBILE_PRICES)
      return prices[this.tierIndex]
    },
    fixedlinePrice () {
      if (this.isRatePlanNew) return NEW_FIXEDLINE_PRICE
      if (this.isRateplanLegacy) {
        return LEGACY_FIXEDLINE_PRICES[this.tierIndex]
      }
      return FIXEDLINE_PRICE
    },
    averageSaving () {
      const noSaving = this.mobileUsageByTierIndex(0) + this.fixedlineUsageByTierIndex(0)
      const saving = this.mobileUsageByTierIndex(this.tierIndex) + this.fixedlineUsageByTierIndex(this.tierIndex)
      return noSaving - saving
    },
    allowCreateCharge () {
      return this.financialData && this.financialData.status === 'ACTIVE'
    },
    isUnlimited () {
      return this.$store.state.auth &&
        this.$store.state.auth.organization &&
        this.$store.state.auth.organization.isUnlimited === true
    },
    showDueDatePicker () {
      return this.isRolloutRechargeDueDate && !this.isUnlimited
    },
    minDueDate () {
      return this.addDays(MIN_DUE_DATE_DAYS)
    },
    maxDueDate () {
      return this.addDays(MAX_DUE_DATE_DAYS)
    }
  },
  watch: {
    chargeAmount (amount) {
      const $slider = $(`#${this.sliderName}`)
      if ($slider.length && $slider.data('slider')) {
        $slider.slider('setValue', this.getAmountPositionByAmount(amount))
      }
    },
    '$store.state.auth.financialData': function () {
      this.getFinancialData()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/financial';

.support-message-error {
  font-size: large;
}

.charge-add-modal {
  max-width: 650px;
  max-height: 650px;
  margin-left: auto;
  margin-right: auto;

  @include financial-modal-content;

  .charge-add-modal-header {
    @include financial-modal-header;
  }

  .charge-add-modal-body {
    padding: 1.5rem;
    text-align: center;
    color: $financial-text;
  }

  .charge-add-label {
    font-size: 1rem;
    font-weight: 400;
    color: $financial-text;
    margin-bottom: 0.75rem;
  }

  .charge-add-prices {
    margin-bottom: 0.25rem;
  }

  .charge-add-price-label {
    font-size: 1rem;
    color: $financial-text-secondary;
    font-weight: 400;
    margin-bottom: 0.25rem;
  }

  .charge-add-price-value {
    font-size: 1.75rem;
    font-weight: 700;
    color: $financial-text;
    margin-bottom: 0;
  }

  @include financial-form-economy;

  .charge-add-due-date,
  .charge-add-financial-emails {
    text-align: left;
    margin-top: 1.25rem;
  }

  .charge-add-label-icon,
  .charge-add-info-icon {
    color: $financial-text;
    font-size: 1rem;
  }

  .charge-add-email-input {
    border: 1px solid $financial-border;
    border-radius: 4px;
    padding: 0.5rem 0.75rem;
    color: $financial-text;
    font-size: 1rem;
    background-color: #fff;

    &[readonly] {
      background-color: #fff;
    }
  }

  .charge-add-helper {
    font-size: 0.85rem;
    color: $financial-text-secondary;
    margin-top: 0.25rem;
  }

  .charge-limit-message {
    font-size: 0.75rem;
    color: $financial-text-secondary;
    margin: 0.75rem 0 0;
    text-align: left;
    line-height: 1.4;
    display: flex;
    align-items: flex-start;
    gap: 0.35rem;
  }

  .charge-limit-icon {
    font-size: 0.8rem;
    color: $financial-text-secondary;
  }

  .charge-limit-icon-btn {
    border: none;
    background: transparent;
    padding: 0;
    margin-top: 0.15rem;
    line-height: 1;
    cursor: pointer;
  }

  .charge-limit-link {
    color: #2d63f6 !important;
    font-weight: 600;
    margin-left: 0.25rem;
    text-decoration: none;

    &:hover,
    &:focus,
    &:active,
    &:visited {
      color: #2d63f6 !important;
    }

    &:hover,
    &:focus {
      text-decoration: underline;
    }
  }

  .charge-add-modal-footer {
    @include financial-modal-footer;
  }

  .charge-add-btn-cancel {
    @include financial-btn-cancel;
  }

  .charge-add-btn-submit {
    @include financial-btn-submit;
  }
}

.chargeAmount {
  text-align: center;
}

#chargeAsaasSuccess {
  .charge-success-modal {
    max-width: 500px;
  }

  @include financial-success-modal;

  .charge-success-modal-body {
    padding: 1.5rem 1.5rem 1rem;
  }

  .charge-success-cta {
    margin: 0 0 0.5rem;
    font-size: 1rem;
    color: $financial-text;
  }

  .charge-success-link {
    color: darken($financial-green, 6%) !important;
    font-weight: 600;
  }

  .charge-success-link:hover {
    color: darken($financial-green, 12%) !important;
  }

  .charge-success-desc {
    font-size: 0.9rem;
    color: $financial-text-secondary;
    margin: 0 0 1.25rem;
    line-height: 1.4;
  }
}
</style>

<style lang="scss">
#chargeRequest .datepicker.dropdown-menu {
  min-width: 280px;
  padding: 0.75rem;
  font-size: 0.95rem;

  .datepicker-days,
  .datepicker-months,
  .datepicker-years,
  .datepicker-decades,
  .datepicker-centuries {
    table {
      width: 100%;

      tr th,
      tr td {
        width: 44px;
        height: 44px;
        line-height: 44px;
        font-size: 0.95rem;
      }

      tr th.datepicker-switch,
      tr th.prev,
      tr th.next {
        font-size: 1rem;
        height: 40px;
        line-height: 40px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Charge/New.vue